import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

export default {
  namespaced: true,
  state () {
    return {
      list: [],
      selectedKey: undefined,
      selectedPaymentData: {
        paymentDate: undefined,
        amount: undefined,
        paymentMethod: undefined,
        ibanDebited: undefined,
        ibanCredited: undefined
      }
    }
  },
  mutations,
  actions,
  getters,
  modules: {

  }
}
